/**
 * "Can the producer see this crew member on the map?"
 *
 * Two switches have to be on: the master location toggle and the separate
 * "share with producer" opt-out. That rule was written out in four places —
 * the crew app's home banner, the screen the nudge push opens, the producer's
 * crew list, and the edge function that sends the nudge — in two dialects
 * (`a && b` truthiness in one pair, `!== false` in the other). The dialects
 * disagree on a null: a crew member with no settings row read as "not sharing"
 * on one surface and "sharing" on another.
 *
 * The failure that made this worth centralising: if a third switch ever joins
 * the rule, the home banner keeps nagging while the screen it opens shows
 * everything already on.
 *
 * The edge function cannot import this (Deno, no workspace packages) and keeps
 * a mirrored copy — see notify-tracking-consent/selectCrewToNudge.ts.
 */

export interface TrackingConsentSettings {
  location_tracking_enabled?: boolean | null;
  share_location_with_producer?: boolean | null;
}

/**
 * A `null`/missing switch counts as ON: the column defaults to true and a
 * crew member who has never opened the app has not opted out of anything.
 * Claiming they did would be the same wrong answer in the other direction.
 */
export function isSharingWithProducer(
  settings: TrackingConsentSettings | null | undefined,
): boolean {
  if (!settings) return true;
  return (
    settings.location_tracking_enabled !== false && settings.share_location_with_producer !== false
  );
}
